import React from "react";
import "../styles/FeeModules.css";

export default function BulkFeeUpload() {
  return (
    <div className="bulk-fee-upload-container">
      <h2>Bulk Fee Upload</h2>
      <p>Upload fee data for multiple students using Excel (.xlsx/.csv).</p>
      {/* Provide an upload form here */}
      <input type="file" accept=".csv, .xlsx" />
      <button className="fee-action-btn" style={{marginLeft: 10}}>Upload</button>
      <p style={{marginTop:12, fontSize:"0.97em", color:"#444"}}>Download sample Excel format for bulk upload.</p>
      <button className="fee-action-btn">Download Sample</button>
    </div>
  );
}